export default {
  title: {
    main: 'Excluir domínio principal: {domain}',
    alternative: 'Excluir domínio: {domain}'
  },
  description: `<span class="d-block">Após a exclusão, seu site será vinculado ao domínio temporário {temporaryDomain}.</span>
                <span class="d-block">Se desejar, você pode adicionar outro domínio principal.</span>`,
  confirmText: {
    main: 'Tem certeza que deseja excluir o domínio principal {domain}?',
    alternative: 'Tem certeza que deseja excluir este domínio?'
  },
  confirmAction: {
    main: 'Excluir domínio principal',
    alternative: 'Excluir domínio'
  },
  cancelAction: 'Cancelar',
  successNotification: 'Domínio excluído com sucesso.',
  failedNotification: 'Erro ao excluir domínio.'
}
